import { Box, type BoxProps, desktopFirstMediaQuery } from '@inflearn/ds-react';
import type { ReactNode } from 'react';

type Props = {
  children: ReactNode;
  gap?: number | string;
  mobileGap?: number | string;
  mobileViewColumns?: number;
} & BoxProps;

export default function GridList({
  children,
  gap = '24px 16px',
  mobileGap = '16px 8px',
  mobileViewColumns = 2,
  ...props
}: Props) {
  return (
    <Box
      component="ul"
      css={{
        display: 'grid',
        gap: gap,
        gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
        [desktopFirstMediaQuery.mobile]: {
          gap: mobileGap,
          gridTemplateColumns: `repeat(${mobileViewColumns}, minmax(0, 1fr))`,
        },
      }}
      {...props}
    >
      {children}
    </Box>
  );
}
